import classnames from 'classnames';
import { FC, forwardRef, HTMLAttributes, ReactNode, Ref } from 'react';

type TagNames = 'div' | 'main';

export type ContainerProps = {
  children?: ReactNode;
  className?: string;
  component?: TagNames;
};

type Element = HTMLDivElement & HTMLElement;

type ComponentProps = {
  tagName?: TagNames;
  children: ReactNode;
  ref?: Ref<Element>;
} & HTMLAttributes<Element>;

const Component: FC<ComponentProps> = ({
  tagName: Wrapper = 'div',
  children,
  ...rest
}) => <Wrapper {...rest}>{children}</Wrapper>;

export const Container: FC<ContainerProps> = forwardRef<
  Element,
  ContainerProps
>(({ children, className, component }, ref) => (
  <Component
    tagName={component}
    className={classnames(className, 'container')}
    ref={ref}>
    {children}
  </Component>
));
